import React, { useState } from 'react';
import { SegmentedToggle, Box, Popover } from 'wix-style-react';
import { com } from '../../../../../../generated/proto-generated';
import { useSelector, useDispatch } from 'react-redux';
import { selectSiteActiveLayoutType } from '../../../../../../common/redux/features/siteConfig/selectors';
import { setSiteActiveLayoutType } from '../../../../../../common/redux/features/siteConfig/actions';
import { ApiDisplay, API_TYPES } from '../../../../ApiDisplay';
import { APPEARANCES, Heading } from '../../../../PageElements/Heading';
import { SIZES, Text, WEIGHTS } from '../../../../PageElements/Text';
import style from './RpcRestTypeSwitch.scss';

interface RpcRestTypeSwitchProps {
  hasRest: boolean;
}

export const RpcRestTypeSwitch = ({ hasRest }: RpcRestTypeSwitchProps) => {
  const dispatch = useDispatch();
  const activeLayoutType = useSelector(selectSiteActiveLayoutType);

  const getActiveType = () => {
    if (!hasRest) {
      return API_TYPES.RPC;
    }
    return activeLayoutType === API_TYPES.RPC_REST
      ? API_TYPES.REST
      : activeLayoutType;
  };

  const [isOpen, setIsOpen] = useState(false);

  return (
    <ApiDisplay.RpcRest matchInitialType>
      <Box
        marginBottom="25px"
        align="left"
        verticalAlign="middle"
        className={style.typeSwitchContainer}
        dataHook="rpc-rest-switch-box"
      >
        <Box marginRight="8px">
          <Heading appearance={APPEARANCES.H3}>Syntax</Heading>
        </Box>

        <Popover
          animate
          dataHook="rpc-rest-type-switch-popover"
          flip
          placement="top"
          showArrow
          shown={isOpen}
          maxWidth={156}
          moveBy={{ x: -33 }}
          moveArrowTo={66}
          onMouseEnter={() => {
            setIsOpen(!hasRest);
          }}
          onMouseLeave={() => {
            setIsOpen(false);
          }}
        >
          <Popover.Element>
            <div
              onMouseLeave={() => {
                setIsOpen(false);
              }}
            >
              <SegmentedToggle
                dataHook="rpc-rest-switch"
                onClick={(e, value) =>
                  dispatch(
                    setSiteActiveLayoutType(
                      value as com.wixpress.wixdocs.ViewerConfig.LayoutType,
                    ),
                  )
                }
                disabled={!hasRest}
                defaultSelected={API_TYPES.RPC}
                selected={getActiveType()}
              >
                <SegmentedToggle.Button
                  className={`${style.toggleOption} ${
                    getActiveType() === API_TYPES.REST ? style.selected : ''
                  }`}
                  value={API_TYPES.REST}
                  disabled={!hasRest}
                  dataHook="rest-switch-button"
                >
                  <Text
                    tagName="span"
                    size={SIZES.small}
                    weight={WEIGHTS.normal}
                  >
                    REST
                  </Text>
                </SegmentedToggle.Button>
                <SegmentedToggle.Button
                  className={`${style.toggleOption} ${
                    getActiveType() === API_TYPES.RPC ? style.selected : ''
                  }`}
                  value={API_TYPES.RPC}
                  dataHook="rpc-switch-button"
                >
                  <Text
                    size={SIZES.small}
                    tagName="span"
                    weight={WEIGHTS.normal}
                  >
                    RPC
                  </Text>
                </SegmentedToggle.Button>
              </SegmentedToggle>
            </div>
          </Popover.Element>
          <Popover.Content>
            <Box padding="10px 17px">
              <Text size={SIZES.tiny}>This endpoint doesn't support REST</Text>
            </Box>
          </Popover.Content>
        </Popover>
      </Box>
    </ApiDisplay.RpcRest>
  );
};
